/**
 * Utility for loading/accessing status, modes, types, etc from API
 */
(function() {
    var defaultAccessor = {
            get: function() {
                return {
                    id: '',
                    identifier: '',
                    name: ''
                };
            },
            items: function() {
                return [];
            },
            itemsHash: function() {
                return {};
            }
        },
        defaultPayload = {
            fields: 'id,identifier,parent_id,sequence,is_default,name,config',
            no_limit: true
        },
        defaultOptions = {queue: true};

    fp.map = function() {
        this.__cache = {};
        this.__accessors = {};
    };

    $.extend(fp.map.prototype, {
        load: function () {
            var self = this,
                accessors = this.__accessors,
                promises = [],
                loadOptions,
                payload,
                serviceString;

            _.each(arguments, function(value) {
                loadOptions = {};

                if (_.isObject(value) && value.type != 'fp.service') {
                    $.extend(loadOptions, value);
                    loadOptions.service = value.service || value.serviceCall;
                }
                if(!loadOptions.service) loadOptions.service = value;
                if(!loadOptions.service) {
                    fp.log(value + ' (service call not found).');
                    return;
                }

                payload = _.getObject(loadOptions.payload);
                serviceString = loadOptions.service.toString();
                if(!loadOptions.cacheKey) {
                    if(serviceString == 'service_provider_configurations' && payload.service_provider_type) {
                        if(!loadOptions.cacheKeyPrefix) loadOptions.cacheKeyPrefix = 'spc';
                        loadOptions.multipleKey = 'service_provider_type';
                    }
                    else {
                        if(serviceString == 'tags' && payload.type) {
                            serviceString = payload.type;
                            loadOptions.multipleKey = 'type';
                        }
                    }
                }
                if(!loadOptions.cacheKey) {
                    loadOptions.cacheKey = fpService.getServiceKey(serviceString);
                }
                if(!loadOptions.refresh) {
                    //if multipleKey is passed we need to remove values that have already been loaded
                    if(loadOptions.multipleKey) {
                        var multipleFields = fp.S(payload[loadOptions.multipleKey]).split(',');
                        if(multipleFields.length) {
                            var multipleValues = '',
                                cacheKeyPrefix = loadOptions.cacheKeyPrefix ? loadOptions.cacheKeyPrefix + '_' : '',
                                serviceKey;
                            _.each(multipleFields, function (key) {
                                key = S(key).trim().s;
                                serviceKey = fpService.getServiceKey(cacheKeyPrefix + key);
                                if (!_.has(accessors, serviceKey)) {
                                    if (multipleValues) multipleValues += ',';
                                    multipleValues += (key == 'sale_configuration_type' ? 'offer_config_type' : key);
                                }
                            });

                            if (multipleValues) {
                                payload[loadOptions.multipleKey] = multipleValues;
                            }
                            else return $.when();
                        }
                    }
                    else if(_.has(accessors, loadOptions.cacheKey)) {
                        return $.when();
                    }
                }

                loadOptions.options = $.extend({}, defaultOptions, loadOptions.options);

                if(_.isObject(loadOptions.data)) {
                    self.__applyAccessor(loadOptions.data, loadOptions);
                }
                else {
                    loadOptions.payload = payload = $.extend({}, payload);

                    _.each(defaultPayload, function(value, key) {
                        if(!_.has(payload, key)) payload[key] = value;
                    });

                    if(loadOptions.multipleKey) {
                        if(S(loadOptions.cacheKeyPrefix).startsWith('spc')) {
                            if(!fpConfig.disableInitializeShopping && !_.has(payload, 'store_id')) {
                                payload.store_id = fp.store.id || fp.topStore.id;
                            }

                            delete payload.no_limit;
                            delete payload.fields;
                        }
                        if(payload.fields) {
                            var fields = fpUtil.formatString(',{0},', payload.fields);
                            _.each(['type_id', 'type_identifier'], function(key) {
                                if(fields.indexOf(fpUtil.formatString(',{0},', key)) == -1) payload.fields += ',' + key;
                            });
                        }
                    }

                    if (fpUtil.isNull(payload.no_limit)) delete payload.no_limit;
                    if (fpUtil.isNull(payload.fields)) delete payload.fields;

                    promises.push(self.__loadMap(loadOptions));
                }
            });

            var deferred = $.Deferred();
            $.when.apply($, promises).always(deferred.resolve);

            return deferred
                .promise();
        },
        get: function (ns, defaultValue, disableWarning) {
            var accessors = this.__accessors,
                returnValue;

            if(S(ns).contains('.')) {
                defaultValue = _.getObject(defaultValue, defaultAccessor.get());
                returnValue = fpUtil.getObjectFromNamespace(ns, this.__cache, defaultValue);
            }
            else {
                if(_.has(accessors, ns)) returnValue = accessors[ns];
                else {
                    if(!disableWarning) {
                        fp.logStack(fpUtil.formatString('fp.util.map.load(\'{0}\') needs to be called before calling fp.util.map.get(\'{0}\')', ns));
                    }
                    returnValue = defaultAccessor;
                }
            }

            return returnValue;
        },
        remove: function(cacheKey) {
            delete this.__accessors[cacheKey];
            delete this.__cache[cacheKey];
        },
        flush: function() {
            _.empty(this.__accessors);
            _.empty(this.__cache);
        },
        __loadMap: function(loadOptions) {
            // fp.log('loadMap', loadOptions);
            var self = this,
                promise = _.isObject(loadOptions.service) ? loadOptions.service.get(loadOptions.payload, loadOptions.options) : fp.api(loadOptions.service, loadOptions.payload, loadOptions.options);
            return promise
                .done(function(resp) {
                    if(loadOptions.multipleKey) {
                        self.__applyMultipleAccessors(resp, loadOptions);
                    }
                    else {
                        var accessor = self.__applyAccessor(resp, loadOptions);
                        if (loadOptions.treeify) {
                            fpUtil.treeify(accessor.items(), {
                                childrenField: 'items',
                                sortBy: 'sequence'
                            });
                        }
                    }
                });
        },
        __applyAccessor: function(data, loadOptions) {
            var cache = this.__cache[loadOptions.cacheKey] = {},
                accessors = this.__accessors,
                filter = _.isFunction(loadOptions.filter) && loadOptions.filter,
                items,
                value;

            if(_.isArray(data)) items = data;
            else if(_.isObject(data)) {
                items = _.getArray(data[loadOptions.itemsKey || 'items']);
            }

            for(var n=0; n<items.length; n++) {
                value = items[n];
                if(filter) value = filter(value);

                if(!_.isObject(value)) {
                    items.splice(n, 1);
                    n--;
                    continue;
                }

                cache[value.id] = value;
                if(_.has(value, 'identifier')) cache[value.identifier] = value;
                //else if(_.has(value, 'id')) cache[value.id] = value;
            }

            if(loadOptions.options.sort) fpUtil.sort(items, loadOptions.options.sort);

            cache.items = items;

            return accessors[loadOptions.cacheKey] = {
                get: function(key, attrs) {
                    //if attrs are passed in we need to do a search in cache.items
                    return _.getObject(_.isObject(attrs) ? _.findWhere(cache.items, attrs) : cache[key]);
                },
                items: function(forAutoComplete) {
                    if(!forAutoComplete) return cache.items;

                    // var items = [];
                    // _.each(cache.items, function(item) {
                    //     items.push({label: item.name, value: item.id});
                    // });
                    //
                    // return items;
                    return _.pluck(cache.items, 'name');
                },
                itemsHash: function() {
                    return cache;
                }
            };
        },
        __applyMultipleAccessors: function(data, loadOptions) {
            var cacheMap = this.__cache,
                accessors = this.__accessors,
                multipleFields = fp.S(_.getObject(loadOptions.payload)[loadOptions.multipleKey]).split(','),
                serviceKeys = {},
                cacheKeyPrefix = loadOptions.cacheKeyPrefix ? loadOptions.cacheKeyPrefix + '_' : '',
                isSpcPrefix = S(cacheKeyPrefix).startsWith('spc'),
                serviceProvider,
                items;

            if(_.isArray(data)) items = data;
            else if(_.isObject(data)) items = _.getArray(data.items);

            if(multipleFields.length) {
                _.each(multipleFields, function(serviceKey) {
                    serviceKey = S(serviceKey).trim().s;
                    if(serviceKey == 'offer_config_type') serviceKey = 'sale_configuration_type';
                    serviceKeys[serviceKey] = serviceKey = fpService.getServiceKey(cacheKeyPrefix + serviceKey);
                    var cache = {
                        items: []
                    };
                    cacheMap[serviceKey] = cache;

                    accessors[serviceKey] = {
                        get: function(key, attrs) {
                            //if attrs are passed in we need to do a search in cache.items
                            return _.getObject(_.isObject(attrs) ? _.findWhere(cache.items, attrs) : cache[key]);
                        },
                        items: function() {
                            return cache.items;
                        }
                    };
                });

                _.each(items, function(item) {
                    var cache;
                    if(isSpcPrefix) {
                        serviceProvider = item.service_provider;
                        if(serviceProvider) {
                            key = serviceKeys[serviceProvider.type_identifier];
                            cache = cacheMap[key];
                            if (cache) {
                                cache[serviceProvider.id] = cache[serviceProvider.identifier] = item;
                            }
                        }
                    }
                    else {
                        key = item.type_identifier;
                        if(key == 'offer_config_type') key = 'sale_configuration_type';
                        key = serviceKeys[key];
                        cache = cacheMap[key];
                        if(cache) {
                            cache[item.id] = item;
                            if (_.has(item, 'identifier')) cache[item.identifier] = item;
                        }
                    }

                    if(cache) cache.items.push(item);
                });
            }
        }
    });

    fpUtil.map = new fp.map();
})();